<pcg-resizable-widget showFacility="true">
    <span widget-title>Rx Search</span>
    <div class="rx-actions" widget-subheader>
        <button 
            class="btn-primary"
            (click)="searchRx($safeNavigationMigration(rxNumber?.value))"
        >
            @if (!isSearching()) {
                <i class="pi pi-search"></i>
            }
            {{isSearching() ? "Searching..." : "Search"}}
        </button>
        <input 
            #rxNumber
            class="input-rx" 
            type="text" 
            placeholder="Rx Number…"
            (keydown.enter)="searchRx($safeNavigationMigration(rxNumber?.value))"
        />
    </div>
    <div class="h-100" widget-body>
        @for (order of orders(); track $index) {
            <pcg-link 
                class="rx-item" 
                [href]="redirect(order)"
            >
                <div style="display:flex; flex-direction:column; gap:3px; flex:1;">
                    <div style="display:flex; align-items:center; gap:10px;">
                        <span class="rx-number">{{ order.refillId }}</span>
                        <span class="rx-step-badge">
                            @if (isUser()) {
                                @if (
                                    order.status == "Not Submitted"
                                ) { <span>Not Submitted</span> }
                                @if (
                                    order.status == "Product Prep" 
                                ) { <span>Submitted</span> }
                                @else if (order.status == "Shipping Prep") { <span>In Progress</span> }
                                @else if (order.status == "QC Check") { <span>In Progress</span> }
                                @else if (order.status == "Pending Shipment") { <span>Fulfilled</span> }
                                @else if (
                                    order.status == "Completed"
                                    && order.dateDelivered == null
                                ) { <span>Shipped</span> }
                                @else if (
                                    order.status == "Completed"
                                    && order.dateDelivered != null
                                ) { <span>Delivered</span> }
                            } @else { {{ order.status }} }					
                        </span>
                    </div>
                    <span style="font-size:11px; color:#9aabba; font-family:'DM Mono',monospace;">{{ order.dateRequested }}</span>
                </div>
            </pcg-link>
        } @empty { <div class="text-center text-muted py-3">{{noOrdersText()}}</div> }
        </div>

</pcg-resizable-widget>